import _ from 'lodash'
import React, {
  useContext,
  useReducer,
  useState,
  createContext,
  useMemo,
} from 'react'
import { IDiamond } from 'types/diamond.types'
import {
  DiamondFilterAPIContextType,
  DiamondFilterContextType,
  IDiamondFilter,
  DiamondFilterActions,
  DiamondDataContextType,
} from 'types/diamondFilter.types'

const DiamondFilterContext = createContext<DiamondFilterContextType | null>(
  null
)
const DiamondFilterAPIContext =
  createContext<DiamondFilterAPIContextType | null>(null)
const DiamondDataContext = createContext<DiamondDataContextType | null>(null)

const diamondFilterReducer = (
  state: IDiamondFilter,
  action: DiamondFilterActions
): IDiamondFilter => {
  switch (action.type) {
    case 'updateShape':
      if (state.labCreated) {
        if (action.shape === 'RB') {
          const newCutLabels = state.activeCutLabels.map((label) => {
            if (label === 'Signature Ideal') {
              return 'Excellent'
            } else if (label === 'Super Ideal') {
              return 'Signature Ideal'
            } else {
              return label
            }
          })
          return {
            ...state,
            shape: action.shape,
            activeCutLabels: newCutLabels,
            page: 1,
          }
        } else {
          const newCutLabels = state.activeCutLabels.map((label) => {
            if (label === 'Excellent') {
              return 'Signature Ideal'
            } else if (
              label === 'Signature Ideal' &&
              action.prevShape === 'RB'
            ) {
              return 'Super Ideal'
            } else {
              return label
            }
          })
          return {
            ...state,
            shape: action.shape,
            activeCutLabels: newCutLabels,
            page: 1,
          }
        }
      } else {
        if (action.shape === 'RB') {
          const newCutLabels = state.activeCutLabels.map((label) => {
            if (label === 'Signature Ideal') {
              return 'Excellent'
            } else {
              return label
            }
          })
          return {
            ...state,
            shape: action.shape,
            activeCutLabels: newCutLabels,
            page: 1,
          }
        } else {
          const newCutLabels = state.activeCutLabels.map((label) => {
            if (label === 'Excellent') {
              return 'Signature Ideal'
            } else {
              return label
            }
          })
          return {
            ...state,
            shape: action.shape,
            activeCutLabels: newCutLabels,
            page: 1,
          }
        }
      }
    case 'updateFtcLink':
      return {
        ...state,
        withFtcLink: action.withFtcLink, 
        page: 1, 
      }  
    case 'updatePrice':
      return {
        ...state,
        minPrice: action.min,
        maxPrice: action.max,
        sliderPriceValue: action.sliderValues,
        page: 1,
      }
    case 'updateCarat':
      return {
        ...state,
        minCarat: action.min,
        maxCarat: action.max,
        sliderCaratValue: action.sliderValues,
        page: 1,
      }
    case 'updateCut':
      return {
        ...state,
        minCut: action.min,
        maxCut: action.max,
        sliderCutValue: action.sliderValues,
        activeCutLabels: action.activeLabels,
        page: 1,
      }
    case 'updateColor':
      return {
        ...state,
        minColor: action.min,
        maxColor: action.max,
        sliderColorValue: action.sliderValues,
        activeColorLabels: action.activeLabels,
        page: 1,
      }
    case 'updateClarity':
      return {
        ...state,
        minClarity: action.min,
        maxClarity: action.max,
        sliderClarityValue: action.sliderValues,
        activeClarityLabels: action.activeLabels,
        page: 1,
      }
    case 'updatePolish':
      return {
        ...state,
        minPolish: action.min,
        maxPolish: action.max,
        sliderPolishValue: action.sliderValues,
        activePolishLabels: action.activeLabels,
        page: 1,
      }
    case 'updateSelectivePolish':
      return {
        ...state,
        selectivePolishValues: action.selectivePolishValues,
      }
    case 'updateSymmetry':
      return {
        ...state,
        minSymmetry: action.min,
        maxSymmetry: action.max,
        sliderSymmetryValue: action.sliderValues,
        activeSymmetryLabels: action.activeLabels,
        page: 1,
      }
    case 'updateSelectiveSymmetry':
      return {
        ...state,
        selectiveSymmetryValues: action.selectiveSymmetryValues,
      }
    case 'updateFluorescence':
      return {
        ...state,
        minFluorescence: action.min,
        maxFluorescence: action.max,
        sliderFluorescenceValue: action.sliderValues,
        activeFluorescenceLabels: action.activeLabels,
        page: 1,
      }
    case 'updateSelectiveFluorescence':
      // The selectiveFluorescenceValues are set by inputs so we don't need to convert any fluorescence values.
      // We can directly set "6" for "None" fluorescence values.
      return {
        ...state,
        selectiveFluorescenceValues: action.selectiveFluorescenceValues,
      }
    case 'updateDepth':
      return {
        ...state,
        minDepth: action.min,
        maxDepth: action.max,
        sliderDepthValue: action.sliderValues,
        page: 1,
      }
    case 'updateTable':
      return {
        ...state,
        minTable: action.min,
        maxTable: action.max,
        sliderTableValue: action.sliderValues,
        page: 1,
      }
    case 'updateRatio':
      return {
        ...state,
        minRatio: action.min,
        maxRatio: action.max,
        sliderRatioValue: action.sliderValues,
        page: 1,
      }
    case 'updateGia':
      return { ...state, giaCert: action.value, page: 1 }
    case 'updateGcal':
      return { ...state, gcalCert: action.value, page: 1 }
    case 'updateIgi':
      return { ...state, igiCert: action.value, page: 1 }
    case 'updateWithImg':
      return { ...state, withImg: action.value, page: 1 }
    case 'updateSameDay':
      return {
        ...state,
        sameDayInStorePickup: action.value,
        page: 1,
      }
    case 'updateQuickShip':
      return {
        ...state,
        quickShip: action.value,
        page: 1,
      }
    case 'updateSort':
      return {
        ...state,
        sort: action.sort,
        direction: action.direction,
        sortOptionName: action.sortOptionName,
        page: 1,
      }
    case 'updatePage':
      return { ...state, page: action.value }
    case 'resetShape':
      return {
        ...state,
        shape: initialNaturalDiamondFilterState.shape,
        page: 1,
      }
    case 'resetPrice':
      return {
        ...state,
        minPrice: initialNaturalDiamondFilterState.minPrice,
        maxPrice: initialNaturalDiamondFilterState.maxPrice,
        sliderPriceValue: initialNaturalDiamondFilterState.sliderPriceValue,
        page: 1,
      }
    case 'resetCarat':
      return {
        ...state,
        minCarat: initialNaturalDiamondFilterState.minCarat,
        maxCarat: initialNaturalDiamondFilterState.maxCarat,
        sliderCaratValue: initialNaturalDiamondFilterState.sliderCaratValue,
        page: 1,
      }
    case 'resetCut':
      if (state.labCreated) {
        if (state.shape === 'RB') {
          return {
            ...state,
            minCut: initialLabDiamondFilterState.minCut,
            maxCut: initialLabDiamondFilterState.maxCut,
            sliderCutValue: initialLabDiamondFilterState.sliderCutValue,
            activeCutLabels: initialLabDiamondFilterState.activeCutLabels,
            page: 1,
          }
        } else {
          return {
            ...state,
            minCut: initialLabDiamondFilterState.minCut,
            maxCut: initialLabDiamondFilterState.maxCut,
            sliderCutValue: initialLabDiamondFilterState.sliderCutValue,
            activeCutLabels: [
              'Good',
              'Very Good',
              'Signature Ideal',
              'Super Ideal',
            ],
            page: 1,
          }
        }
      } else {
        if (state.shape === 'RB') {
          return {
            ...state,
            minCut: initialNaturalDiamondFilterState.minCut,
            maxCut: initialNaturalDiamondFilterState.maxCut,
            sliderCutValue: initialNaturalDiamondFilterState.sliderCutValue,
            activeCutLabels: initialNaturalDiamondFilterState.activeCutLabels,
            page: 1,
          }
        } else {
          return {
            ...state,
            minCut: initialNaturalDiamondFilterState.minCut,
            maxCut: initialNaturalDiamondFilterState.maxCut,
            sliderCutValue: initialNaturalDiamondFilterState.sliderCutValue,
            activeCutLabels: ['Good', 'Very Good', 'Signature Ideal'],
            page: 1,
          }
        }
      }
    case 'resetColor':
      if (state.labCreated) {
        return {
          ...state,
          minColor: initialLabDiamondFilterState.minColor,
          maxColor: initialLabDiamondFilterState.maxColor,
          sliderColorValue: initialLabDiamondFilterState.sliderColorValue,
          activeColorLabels: initialLabDiamondFilterState.activeColorLabels,
          page: 1,
        }
      } else {
        return {
          ...state,
          minColor: initialNaturalDiamondFilterState.minColor,
          maxColor: initialNaturalDiamondFilterState.maxColor,
          sliderColorValue: initialNaturalDiamondFilterState.sliderColorValue,
          activeColorLabels: initialNaturalDiamondFilterState.activeColorLabels,
          page: 1,
        }
      }
    case 'resetClarity':
      if (state.labCreated) {
        return {
          ...state,
          minClarity: initialLabDiamondFilterState.minClarity,
          maxClarity: initialLabDiamondFilterState.maxClarity,
          sliderClarityValue: initialLabDiamondFilterState.sliderClarityValue,
          activeClarityLabels: initialLabDiamondFilterState.activeClarityLabels,
          page: 1,
        }
      } else {
        return {
          ...state,
          minClarity: initialNaturalDiamondFilterState.minClarity,
          maxClarity: initialNaturalDiamondFilterState.maxClarity,
          sliderClarityValue:
            initialNaturalDiamondFilterState.sliderClarityValue,
          activeClarityLabels:
            initialNaturalDiamondFilterState.activeClarityLabels,
          page: 1,
        }
      }
    case 'resetPolish':
      return {
        ...state,
        minPolish: initialNaturalDiamondFilterState.minPolish,
        maxPolish: initialNaturalDiamondFilterState.maxPolish,
        sliderPolishValue: initialNaturalDiamondFilterState.sliderPolishValue,
        activePolishLabels: initialNaturalDiamondFilterState.activePolishLabels,
        selectivePolishValues:
          initialNaturalDiamondFilterState.selectivePolishValues,
        page: 1,
      }
    case 'resetSymmetry':
      if (state.labCreated) {
        return {
          ...state,
          minSymmetry: initialLabDiamondFilterState.minSymmetry,
          maxSymmetry: initialLabDiamondFilterState.maxSymmetry,
          sliderSymmetryValue: initialLabDiamondFilterState.sliderSymmetryValue,
          activeSymmetryLabels:
            initialLabDiamondFilterState.activeSymmetryLabels,
          selectiveSymmetryValues:
            initialNaturalDiamondFilterState.selectiveSymmetryValues,
          page: 1,
        }
      } else {
        return {
          ...state,
          minSymmetry: initialNaturalDiamondFilterState.minSymmetry,
          maxSymmetry: initialNaturalDiamondFilterState.maxSymmetry,
          sliderSymmetryValue:
            initialNaturalDiamondFilterState.sliderSymmetryValue,
          activeSymmetryLabels:
            initialNaturalDiamondFilterState.activeSymmetryLabels,
          selectiveSymmetryValues:
            initialNaturalDiamondFilterState.selectiveSymmetryValues,
          page: 1,
        }
      }

    case 'resetFluorescence':
      if (state.labCreated) {
        return {
          ...state,
          minFluorescence: initialLabDiamondFilterState.minFluorescence,
          maxFluorescence: initialLabDiamondFilterState.maxFluorescence,
          sliderFluorescenceValue:
            initialLabDiamondFilterState.sliderFluorescenceValue,
          activeFluorescenceLabels:
            initialLabDiamondFilterState.activeFluorescenceLabels,
          selectiveFluorescenceValues:
            initialLabDiamondFilterState.selectiveFluorescenceValues,
          page: 1,
        }
      } else {
        return {
          ...state,
          minFluorescence: initialNaturalDiamondFilterState.minFluorescence,
          maxFluorescence: initialNaturalDiamondFilterState.maxFluorescence,
          sliderFluorescenceValue:
            initialNaturalDiamondFilterState.sliderFluorescenceValue,
          activeFluorescenceLabels:
            initialNaturalDiamondFilterState.activeFluorescenceLabels,
          selectiveFluorescenceValues:
            initialNaturalDiamondFilterState.selectiveFluorescenceValues,
          page: 1,
        }
      }
    case 'resetDepth':
      return {
        ...state,
        minDepth: initialNaturalDiamondFilterState.minDepth,
        maxDepth: initialNaturalDiamondFilterState.maxDepth,
        sliderDepthValue: initialNaturalDiamondFilterState.sliderDepthValue,
        page: 1,
      }
    case 'resetTable':
      return {
        ...state,
        minTable: initialNaturalDiamondFilterState.minTable,
        maxTable: initialNaturalDiamondFilterState.maxTable,
        sliderTableValue: initialNaturalDiamondFilterState.sliderTableValue,
        page: 1,
      }
    case 'resetRatio':
      return {
        ...state,
        minRatio: initialNaturalDiamondFilterState.minRatio,
        maxRatio: initialNaturalDiamondFilterState.maxRatio,
        sliderRatioValue: initialNaturalDiamondFilterState.sliderRatioValue,
        page: 1,
      }
    case 'resetCertificates':
      return { ...state, giaCert: true, gcalCert: true, igiCert: true, page: 1 }
    case 'resetFilters':
      if (state.labCreated) {
        return { ...initialLabDiamondFilterState }
      } else {
        return { ...initialNaturalDiamondFilterState }
      }
  }
}

export const initialNaturalDiamondFilterState: IDiamondFilter = {
  shape: 'RB',
  minPrice: 100,
  maxPrice: 2000000,
  sliderPriceValue: [0, 199],
  minCarat: '0.7',
  maxCarat: '20.0',
  sliderCaratValue: [50, 232],
  minCut: 2,
  maxCut: 3,
  sliderCutValue: [2, 3],
  activeCutLabels: ['Excellent'],
  minColor: 0,
  maxColor: 9,
  sliderColorValue: [0, 9],
  activeColorLabels: ['L', 'K', 'J', 'I', 'H', 'G', 'F', 'E', 'D'],
  minClarity: 2,
  maxClarity: 10,
  sliderClarityValue: [2, 10],
  activeClarityLabels: ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL'],
  minPolish: 4,
  maxPolish: 5,
  sliderPolishValue: [4, 5],
  activePolishLabels: ['Excellent'],
  selectivePolishValues: [],
  minSymmetry: 4,
  maxSymmetry: 5,
  sliderSymmetryValue: [4, 5],
  activeSymmetryLabels: ['Excellent'],
  selectiveSymmetryValues: [],
  minFluorescence: 1,
  maxFluorescence: 5,
  sliderFluorescenceValue: [1, 5],
  activeFluorescenceLabels: ['Strong', 'Medium', 'Faint', 'None'],
  selectiveFluorescenceValues: [],
  minDepth: '43',
  maxDepth: '88',
  sliderDepthValue: [43, 88],
  minTable: 48,
  maxTable: 85,
  sliderTableValue: [48, 85],
  minRatio: 1,
  maxRatio: 2.5,
  sliderRatioValue: [1, 2.5],
  withImg: false,
  sameDayInStorePickup: false,
  quickShip: false,
  giaCert: false,
  gcalCert: false,
  igiCert: false,
  labCreated: false,
  page: 1,
  perPage: 20,
  sort: '',
  direction: '',
  sortOptionName: '',
  withFtcLink: false,
}

// Verificar si estamos en el cliente
if (typeof window !== 'undefined') {
  const savedFilters = JSON.parse(localStorage.getItem('search-diamonds') || '{}');
  if (savedFilters.withFtcLink !== undefined) {
    initialNaturalDiamondFilterState.withFtcLink = savedFilters.withFtcLink;
  }
}

export const initialLabDiamondFilterState: IDiamondFilter = {
  shape: 'RB',
  minPrice: 100,
  maxPrice: 2000000,
  sliderPriceValue: [0, 199],
  minCarat: '0.7',
  maxCarat: '20.0',
  sliderCaratValue: [50, 232],
  minCut: 2,
  maxCut: 3,
  sliderCutValue: [2, 3],
  activeCutLabels: ['Excellent'],
  minColor: 5,
  maxColor: 9,
  sliderColorValue: [5, 9],
  activeColorLabels: ['G', 'F', 'E', 'D'],
  minClarity: 4,
  maxClarity: 10,
  sliderClarityValue: [4, 10],
  activeClarityLabels: ['VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL'],
  minPolish: 4,
  maxPolish: 5,
  sliderPolishValue: [4, 5],
  activePolishLabels: ['Excellent'],
  selectivePolishValues: [],
  minSymmetry: 4,
  maxSymmetry: 5,
  sliderSymmetryValue: [4, 5],
  activeSymmetryLabels: ['Excellent'],
  selectiveSymmetryValues: [],
  minFluorescence: 0,
  maxFluorescence: 5,
  sliderFluorescenceValue: [0, 5],
  activeFluorescenceLabels: [
    'Very Strong',
    'Strong',
    'Medium',
    'Faint',
    'None',
  ],
  selectiveFluorescenceValues: [],
  minDepth: '43',
  maxDepth: '88',
  sliderDepthValue: [43, 88],
  minTable: 48,
  maxTable: 85,
  sliderTableValue: [48, 85],
  minRatio: 1,
  maxRatio: 2.5,
  sliderRatioValue: [1, 2.5],
  withImg: false,
  sameDayInStorePickup: false,
  quickShip: false,
  giaCert: false,
  gcalCert: false,
  igiCert: false,
  labCreated: true,
  page: 1,
  perPage: 20,
  sort: '',
  direction: '',
  sortOptionName: '',
  withFtcLink: false,
}

interface ProviderProps {
  children: React.ReactNode
  diamondType?: 'natural' | 'lab'
}
type Meta = {
  count: number
  total_count: number
  total_pages: number
}
const DiamondFilterProvider: React.FC<ProviderProps> = ({
  children,
  diamondType = 'natural',
}) => {
  const [diamondFilterState, dispatch] = useReducer(
    diamondFilterReducer,
    diamondType === 'natural'
      ? initialNaturalDiamondFilterState
      : initialLabDiamondFilterState
  )
  const [loadingDiamonds, setLoadingDiamonds] = useState(true)
  const [diamondData, setDiamondData] = useState<IDiamond[] | null>(null)
  const [diamondMeta, setDiamondMeta] = useState<Meta>({
    count: 0,
    total_count: 0,
    total_pages: 0,
  })

  const api = useMemo(() => {
    const onShapeUpdate = (shape: string, prevShape: string) => {
      dispatch({ type: 'updateShape', shape, prevShape })
    }

    const onPriceUpdate = (
      min: number,
      max: number,
      sliderValues: [number, number]
    ) => {
      dispatch({ type: 'updatePrice', min, max, sliderValues })
    }

    const onFtcLinkUpdate = (withFtcLink: boolean) => {
      dispatch({ type: 'updateFtcLink', withFtcLink })
    }

    const onCaratUpdate = (
      min: string,
      max: string,
      sliderValues: [number, number]
    ) => {
      dispatch({ type: 'updateCarat', min, max, sliderValues })
    }

    const onCutUpdate = (
      min: number,
      max: number,
      sliderValues: [number, number],
      activeLabels: string[]
    ) => {
      dispatch({ type: 'updateCut', min, max, sliderValues, activeLabels })
    }

    const onColorUpdate = (
      min: number,
      max: number,
      sliderValues: [number, number],
      activeLabels: string[]
    ) => {
      dispatch({ type: 'updateColor', min, max, sliderValues, activeLabels })
    }

    const onClarityUpdate = (
      min: number,
      max: number,
      sliderValues: [number, number],
      activeLabels: string[]
    ) => {
      dispatch({ type: 'updateClarity', min, max, sliderValues, activeLabels })
    }

    const onPolishUpdate = (
      min: number,
      max: number,
      sliderValues: [number, number],
      activeLabels: string[]
    ) => {
      dispatch({ type: 'updatePolish', min, max, sliderValues, activeLabels })
    }

    const onSelectivePolishUpdate = (selectivePolishValues: number[]) => {
      dispatch({
        type: 'updateSelectivePolish',
        selectivePolishValues,
      })
    }

    const onSymmetryUpdate = (
      min: number,
      max: number,
      sliderValues: [number, number],
      activeLabels: string[]
    ) => {
      dispatch({ type: 'updateSymmetry', min, max, sliderValues, activeLabels })
    }

    const onSelectiveSymmetryUpdate = (selectiveSymmetryValues: number[]) => {
      dispatch({
        type: 'updateSelectiveSymmetry',
        selectiveSymmetryValues,
      })
    }

    const onFluorescenceUpdate = (
      min: number,
      max: number,
      sliderValues: [number, number],
      activeLabels: string[]
    ) => {
      dispatch({
        type: 'updateFluorescence',
        min,
        max,
        sliderValues,
        activeLabels,
      })
    }

    const onSelectiveFluorescenceUpdate = (
      selectiveFluorescenceValues: number[]
    ) => {
      dispatch({
        type: 'updateSelectiveFluorescence',
        selectiveFluorescenceValues,
      })
    }

    const onDepthUpdate = (
      min: string,
      max: string,
      sliderValues: [number, number]
    ) => {
      dispatch({ type: 'updateDepth', min, max, sliderValues })
    }

    const onTableUpdate = (
      min: number,
      max: number,
      sliderValues: [number, number]
    ) => {
      dispatch({ type: 'updateTable', min, max, sliderValues })
    }

    const onRatioUpdate = (
      min: number,
      max: number,
      sliderValues: [number, number]
    ) => {
      dispatch({ type: 'updateRatio', min, max, sliderValues })
    }

    const onGiaUpdate = (value: boolean) => {
      dispatch({ type: 'updateGia', value })
    }

    const onGcalUpdate = (value: boolean) => {
      dispatch({ type: 'updateGcal', value })
    }

    const onIgiUpdate = (value: boolean) => {
      dispatch({ type: 'updateIgi', value })
    }

    const onWithImgUpdate = (value: boolean) => {
      dispatch({ type: 'updateWithImg', value })
    }

    const onSameDayUpdate = (value: boolean) => {
      dispatch({ type: 'updateSameDay', value })
    }

    const onQuickShipUpdate = (value: boolean) => {
      dispatch({ type: 'updateQuickShip', value })
    }

    const onSortUpdate = (
      sort: string,
      direction: string,
      sortOptionName: string
    ) => {
      dispatch({ type: 'updateSort', sort, direction, sortOptionName })
    }

    const onPageUpdate = (value: number) => {
      dispatch({ type: 'updatePage', value })
    }

    const onResetShape = () => {
      dispatch({ type: 'resetShape' })
    }

    const onResetPrice = () => {
      dispatch({ type: 'resetPrice' })
    }

    const onResetCarat = () => {
      dispatch({ type: 'resetCarat' })
    }

    const onResetCut = () => {
      dispatch({ type: 'resetCut' })
    }

    const onResetColor = () => {
      dispatch({ type: 'resetColor' })
    }

    const onResetClarity = () => {
      dispatch({ type: 'resetClarity' })
    }

    const onResetPolish = () => {
      dispatch({ type: 'resetPolish' })
    }

    const onResetSymmetry = () => {
      dispatch({ type: 'resetSymmetry' })
    }

    const onResetFluorescence = () => {
      dispatch({ type: 'resetFluorescence' })
    }

    const onResetDepth = () => {
      dispatch({ type: 'resetDepth' })
    }

    const onResetTable = () => {
      dispatch({ type: 'resetTable' })
    }

    const onResetRatio = () => {
      dispatch({ type: 'resetRatio' })
    }

    const onResetCertificates = () => {
      dispatch({ type: 'resetCertificates' })
    }

    const onResetFilters = () => {
      dispatch({ type: 'resetFilters' })
    }

    return {
      onShapeUpdate,
      onPriceUpdate,
      onCaratUpdate,
      onCutUpdate,
      onColorUpdate,
      onClarityUpdate,
      onPolishUpdate,
      onSelectivePolishUpdate,
      onSymmetryUpdate,
      onSelectiveSymmetryUpdate,
      onFluorescenceUpdate,
      onSelectiveFluorescenceUpdate,
      onDepthUpdate,
      onTableUpdate,
      onRatioUpdate,
      onGiaUpdate,
      onGcalUpdate,
      onIgiUpdate,
      onWithImgUpdate,
      onSameDayUpdate,
      onQuickShipUpdate,
      onSortUpdate,
      onPageUpdate,
      onResetShape,
      onResetPrice,
      onResetCarat,
      onResetCut,
      onResetColor,
      onResetClarity,
      onResetPolish,
      onResetSymmetry,
      onResetFluorescence,
      onResetDepth,
      onResetTable,
      onResetRatio,
      onResetCertificates,
      onResetFilters,
      onFtcLinkUpdate
    }
  }, [])

  return (
    <DiamondFilterAPIContext.Provider value={api}>
      <DiamondDataContext.Provider
        value={{
          loadingDiamonds,
          setLoadingDiamonds,
          diamondData,
          setDiamondData,
          diamondMeta,
          setDiamondMeta,
        }}
      >
        <DiamondFilterContext.Provider value={{ diamondFilterState }}>
          {children}
        </DiamondFilterContext.Provider>
      </DiamondDataContext.Provider>
    </DiamondFilterAPIContext.Provider>
  )
}

export const useDiamondFilterState = () => {
  const context = useContext(DiamondFilterContext)
  if (context === undefined) {
    throw new Error(
      `useDiamondFilterState must be used within a DiamondFilterProvider`
    )
  }
  return context
}

export const useDiamondFilterAPI = () => {
  const context = useContext(DiamondFilterAPIContext)
  if (context === undefined) {
    throw new Error(
      `useDiamondFilterAPI must be used within a DiamondFilterProvider`
    )
  }
  return context
}

export const useDiamondData = () => {
  const context = useContext(DiamondDataContext)
  if (context === undefined) {
    throw new Error(
      `useDiamondData must be used within a DiamondFilterProvider`
    )
  }
  return context
}

export default DiamondFilterProvider
